import gsap from "gsap";
import { type ReactNode, useLayoutEffect, useRef } from "react";

type ModalContentFadeInProps = {
	children: ReactNode;
	className?: string;
};

// Обертка для плавного появления контента
export const ModalContentFadeIn = ({
	children,
	className,
}: ModalContentFadeInProps) => {
	const rootRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const el = rootRef.current;
		if (!el) return;

		const reduced =
			typeof window !== "undefined" &&
			window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		if (reduced) {
			gsap.set(el, { opacity: 1 });
			return;
		}

		gsap.killTweensOf(el);
		gsap.fromTo(
			el,
			{ opacity: 0, y: 5 },
			{
				opacity: 1,
				y: 0,
				duration: 0.38,
				ease: "power2.out",
				clearProps: "transform",
			},
		);

		return () => {
			gsap.killTweensOf(el);
		};
	}, []);

	return (
		<div ref={rootRef} className={className}>
			{children}
		</div>
	);
};
